import type React from "react";
import OcidOauthFlow from "./components/OcidOauthFlow";
import OAuthFlow from "./components/OAuthFlow";

const App: React.FC = () => {
  const appType = new URLSearchParams(window.location.search).get("app_type");
  if (appType === "claude") {
    return <OcidOauthFlow />;
  }
  return <OAuthFlow />;
};

export default App;
